import * as api from "@/api";

const initState = () => ({
  alerts: [],
  refresh: null,
  intervalId: null,
});

export default {
  namespaced: true,
  state: initState,
  getters: {},
  mutations: {
    setAlerts: (state, value) => (state.alerts = value),
    setIntervalId: (state, id) => (state.intervalID = id),
    clearAlerts: (state) => (state.alerts = []),
    setRefresh: (state, value) => (state.refresh = value),
    deleteAlertId: (state, id) => {
      let i = state.alerts.findIndex((el) => el.alert_id === id);
      if (i >= 0) {
        state.alerts.splice(i, 1);
      }
    },

    reset: (state) => {
      // сначала удалить интервал текущий
      clearInterval(state.intervalID)
      const initialState = initState();
      Object.keys(initialState).forEach((key) => (state[key] = initialState[key]));
    },
  },
  actions: {
    async getAlerts({ commit }) {
      const res = await api.getAlerts();
      if (res) {
        commit("setAlerts", res.alerts);
      }
    },

    async clearAlerts({ commit }) {
      await api.clearAlerts();
      if (res) {
        commit("clearAlerts", []);
      }
    },

    async deleteAlert({ commit, dispatch }, id) {
      const res = await api.deleteAlert(id);
      if (res) {
        commit("deleteAlertId", id);
        dispatch("refreshCountBackground");
      }
    },

    async refreshCountBackground({ commit }) {
      const res = await api.refreshCountBackground();
      if (res) {
        commit("setRefresh", res.alerts);
      }
    },

    async refreshTime({ commit, state }) {
      if (state.intervalId === null) {
        let id = setInterval(async () => {
          if (!document.hidden) {
            // вкладка открыта
            const res = await api.refreshCountBackground();
            if (res) {
              commit("setRefresh", res.alerts);
            }
          }
        }, 60000);
        commit("setIntervalId", id);
      }
    },
  },
};
